import React from 'react';
import { observer } from 'mobx-react';
import { Trans } from 'react-i18next';
import PropTypes from 'prop-types';

import { Label, FormWrapperDiv } from 'libs/forms/styles';
import { TextField } from 'libs/forms/views/fieldTypes/text';
import { CouponStyle, ButtonStyled } from 'apps/payment/styles';

import { Center } from 'legacyComponents/styled/lib';

export const Coupon = observer(({ paymentSpace }) => {
  const { couponForm, couponFieldVisible, subscription } = paymentSpace;

  if (!subscription || subscription.plan.name.includes('Free')) {
    if (couponForm && couponFieldVisible) {
      return (
        <FormWrapperDiv responsive>
          <Label>
            <Trans>Coupon</Trans>
          </Label>
          <TextField
            autoFocus
            fieldStore={couponForm.fieldStores.get('coupon')}
            responsive
          />
          <Center>
            <ButtonStyled
              text='Cancel'
              onClick={() =>
                paymentSpace.SetCouponFieldVisible(!couponFieldVisible)
              }
              size='small'
              variant='secondary'
              outline
            />
            <ButtonStyled
              text='Claim'
              onClick={paymentSpace.ClaimCoupon}
              size='small'
            />
          </Center>
        </FormWrapperDiv>
      );
    }
    return (
      <CouponStyle
        onClick={() => paymentSpace.SetCouponFieldVisible(!couponFieldVisible)}
      >
        Have a coupon?
      </CouponStyle>
    );
  }
  return null;
});

Coupon.propTypes = {
  planName: PropTypes.string,
  appManager: PropTypes.object,
};
